<template>
    <DxDropDownButton
        :items="items"
        :selected-item-key="mode"
        key-expr="key"
        display-expr="label"
        :icon="iconForMode"
        :drop-down-options="{ width: 180 }"
        :hint="t('theme.label')"
        styling-mode="text"
        :show-arrow-icon="false"
        class="theme-switcher"
        @selection-changed="onSelect"
    />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DxDropDownButton from 'devextreme-vue/drop-down-button'
import { useTheme } from '@/composables/useTheme'

const { t } = useI18n()
const { mode, setMode } = useTheme()

const items = computed(() => [
    { key: 'system', label: t('theme.system'), icon: 'preferences' },
    { key: 'light', label: t('theme.light'), icon: 'sun' },
    { key: 'dark', label: t('theme.dark'), icon: 'moon' },
])

const iconForMode = computed(() => {
    if (mode.value === 'light') return 'sun'
    if (mode.value === 'dark') return 'moon'
    return 'preferences'
})

function onSelect(e) {
    const next = e.item?.key
    if (next) setMode(next)
}
</script>

<style scoped>
.theme-switcher {
    --dx-component-height: 36px;
}

.theme-switcher :deep(.dx-button) {
    min-width: 44px;
    border-radius: var(--gc-radius-md);
}
</style>
